module.exports = __webpack_public_path__ + "assets/img/0412.76bf2449.svg";